import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledTabGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    flex: 1 1 30%;
    margin: 0 ${themeGet('scale.scaleUp03')} 0;
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: ${themeGet('scale.scaleDown03')};

    > div {
      flex: 0;
      margin: 0;
    }
  }
`;

export const StyledTab = styled.div`
  flex-basis: 50%;
  padding: ${themeGet('scale.scaleBase')};
  color: ${themeGet('color.colorGrayBlue70')};
  background-color: ${themeGet('color.colorGrayBlue10')};
  border-top: ${themeGet('border.borderLarge')} solid
    ${themeGet('color.colorGrayBlue60')};
  box-shadow: inset 0 -12px 8px -10px ${themeGet('color.colorGrayBlue20')};
  text-align: center;
  transition: color 0.3s, background-color 0.3s, border-color 0.3s,
    box-shadow 0.3s;
  cursor: pointer;

  @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &[aria-selected='true'],
  &:hover {
    color: ${themeGet('color.colorGrayBlue100')};
    background-color: ${themeGet('color.colorWhite')};
    border-color: ${themeGet('color.colorBlue')};
    box-shadow: none;
  }

  h3 {
    margin-bottom: 0;

    @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
      font-size: ${themeGet('scale.scaleBase')};
    }

    @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
      font-size: ${themeGet('scale.scaleDown01')};
    }
  }

  p {
    margin: 0;
    font-size: ${themeGet('scale.scaleBase')};

    @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
      display: none;
    }
  }
`;
